import api from './api';

export interface DailyProgress {
    day: string;
    date: string;
    lessonsCompleted: number;
}

export interface WeekStats {
    startDate: string;
    endDate: string;
    lessonsCompleted: number;
    coursesCompleted: number;
    timeSpentMinutes: number;
    activeDays: number;
}

export interface TotalStats {
    totalEnrolled: number;
    totalCompleted: number;
    inProgress: number;
    totalLessonsCompleted: number;
    completionRate: number;
}

export interface WeeklyProgressResponse {
    currentWeek: WeekStats;
    lastWeek: {
        lessonsCompleted: number;
        coursesCompleted: number;
        timeSpentMinutes: number;
        activeDays: number;
    };
    comparison: {
        lessonsChange: number;
        coursesChange: number;
        timeChange: number;
    };
    dailyProgress: DailyProgress[];
    totalStats: TotalStats;
}

class ProgressService {
    /**
     * Get weekly progress statistics
     */
    async getWeeklyProgress(): Promise<WeeklyProgressResponse> {
        const response = await api.get<WeeklyProgressResponse>('/progress/weekly');
        return response.data;
    }
}

export const progressService = new ProgressService();
export default progressService;
